import { storeToRefs } from 'pinia'
import { useDmCoreSpaceOperatorStore } from '@nsftx/seven-client-retail-vue-dm-core'
import { useGamesStore } from '@nsftx/seven-client-retail-vue-sgp'
import router from '..'
import { ROUTES_NAMES } from '../routesNames'

const operatorAuthGuard = () => {
  const { isOperatorLoggedIn, operatorData } = storeToRefs(useDmCoreSpaceOperatorStore())
  const { linkGames: games } = storeToRefs(useGamesStore())

  router.beforeEach((to) => {
    const operatorHasPermissions =
      Object.keys(operatorData.value?.permission_category_group_claims ?? {}).length > 0
    const shouldRedirectToAccessDenied = !games.value?.length && !operatorHasPermissions

    if (!isOperatorLoggedIn.value && to.name !== ROUTES_NAMES.login) {
      return { name: ROUTES_NAMES.login }
    }

    if (
      isOperatorLoggedIn.value &&
      shouldRedirectToAccessDenied &&
      to.name !== ROUTES_NAMES.accessDenied
    ) {
      return { name: ROUTES_NAMES.accessDenied }
    }

    if (
      isOperatorLoggedIn.value &&
      !shouldRedirectToAccessDenied &&
      to.name === ROUTES_NAMES.accessDenied
    ) {
      return { name: ROUTES_NAMES.home }
    }
  })
}

export default operatorAuthGuard
